export const limitTextLength = (text?: string, limit?: number) => {
  if (!text) {
    return "";
  }

  if (text.length <= (limit || 20)) {
    return text;
  }

  return text.slice(0, limit || 20) + "...";
};

export const firstCaptial = (txt: string) => {
  // return txt with first letter capital
  if (!txt || txt.length === 0) {
    return "";
  }

  return txt.charAt(0).toUpperCase() + txt.slice(1);
};

function removeStyling(input: string) {
  return input.replace(/[\u{1D400}-\u{1D7FF}]/gu, (char) => {
    const codePoint = char.codePointAt(0)!;

    // Math Sans-Serif Bold Italic a-z (U+1D5A0 - U+1D5B9)
    if (codePoint >= 0x1d5a0 && codePoint <= 0x1d5b9) {
      return String.fromCharCode(0x61 + (codePoint - 0x1d5a0)); // Map to 'a' to 'z'
    }

    // Math Bold a-z (U+1D41A - U+1D433)
    if (codePoint >= 0x1d41a && codePoint <= 0x1d433) {
      return String.fromCharCode(0x61 + (codePoint - 0x1d41a)); // Map to 'a' to 'z'
    }

    // Math Bold A-Z (U+1D400 - U+1D419)
    if (codePoint >= 0x1d400 && codePoint <= 0x1d419) {
      return String.fromCharCode(0x41 + (codePoint - 0x1d400)); // Map to 'A' to 'Z'
    }

    // Math Bold Italic A-Z (U+1D468 - U+1D481)
    if (codePoint >= 0x1d468 && codePoint <= 0x1d481) {
      return String.fromCharCode(0x41 + (codePoint - 0x1d468)); // Map to 'A' to 'Z'
    }

    // Math Sans-Serif Bold A-Z (U+1D5D4 - U+1D5ED)
    if (codePoint >= 0x1d5d4 && codePoint <= 0x1d5ed) {
      return String.fromCharCode(0x41 + (codePoint - 0x1d5d4)); // Map to 'A' to 'Z'
    }

    // Math Sans-Serif Bold a-z (U+1D5EE - U+1D607)
    if (codePoint >= 0x1d5ee && codePoint <= 0x1d607) {
      return String.fromCharCode(0x61 + (codePoint - 0x1d5ee)); // Map to 'a' to 'z'
    }

    // Math Bold Greek A-Z (U+1D6A8 - U+1D6C0)
    if (codePoint >= 0x1d6a8 && codePoint <= 0x1d6c0) {
      return String.fromCharCode(0x391 + (codePoint - 0x1d6a8)); // Map to Greek A-Z
    }

    // Math Bold Greek a-z (U+1D6C1 - U+1D6DB)
    if (codePoint >= 0x1d6c1 && codePoint <= 0x1d6db) {
      return String.fromCharCode(0x3b1 + (codePoint - 0x1d6c1)); // Map to Greek a-z
    }

    // Math Bold Digits 0-9 (U+1D7CE - U+1D7D7)
    if (codePoint >= 0x1d7ce && codePoint <= 0x1d7d7) {
      return String.fromCharCode(0x30 + (codePoint - 0x1d7ce)); // Map to '0' to '9'
    }

    // // Math Bold Digits 0-9 (U+1D7CE - U+1D7D7)
    // if (codePoint >= 0x1d7ce && codePoint <= 0x1d7d7) {
    //   return String.fromCharCode(0x30 + (codePoint - 0x1d7ce)); // Map to '0' to '9'
    // }

    // // Math Sans-Serif Bold Digits 0-9 (U+1D7EC - U+1D7F5)
    if (codePoint >= 0x1d7ec && codePoint <= 0x1d7f5) {
      return String.fromCharCode(0x30 + (codePoint - 0x1d7ec)); // Map to '0' to '9'
    }

    return char; // Remove other styled characters by default
  });
}

export const normalizeText = (text: string) => {
  let result = removeStyling(text);
  let words = result.split(" ");
  let modifiedWords = [];

  for (let word of words) {
    if (word === word.toUpperCase()) {
      modifiedWords.push(word.toLowerCase());
    } else {
      modifiedWords.push(word);
    }
  }

  result = modifiedWords.join(" ");

  return result;
};
